export default __webpack_public_path__ + "static/hinge-5caa7756fbd58b105764307e926ee1ca.png";